import { number } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { getFiles } from 'Redux/modules/webChat/file/actions';
import { useEffect } from 'react';
import { PAGE_SIZE } from 'Constants/webchat';

import EmptyList from '../EmptyList';
import HOCList from '../HOCList';

import styles from './styles.less';
import FileLine from './FileLine';

const FileList = ({ conversationId }) => {
  const dispatch = useDispatch();
  const { list, meta } = useSelector(state => state.webChat.file);

  const page = meta?.pagination?.page || 0;
  const pages = meta?.pagination?.pages || 0;
  const isLoadMore = page < pages;

  const getListFiles = timestamp => {
    dispatch(getFiles({ conversationId, count: PAGE_SIZE, timestamp }, isLoadMore));
  };

  const handleWaypointEnter = () => {
    if (isLoadMore) {
      const timestamp = new Date(list[list.length - 1].createdAt).valueOf();
      if (list[list.length - 1] && conversationId) {
        getListFiles(timestamp);
      }
    }
  };

  useEffect(() => {
    getListFiles();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles.listWrapper}>
      <HOCList onEnter={handleWaypointEnter} isLoadMore={isLoadMore}>
        {list.map(item => (
          <FileLine key={item.id} file={item} />
        ))}
      </HOCList>
      {list.length === 0 && <EmptyList text="No files yet" />}
    </div>
  );
};

FileList.propTypes = {
  conversationId: number.isRequired,
};

export default FileList;
